import { TabList, TabPanel, TabPanelProps } from "@mui/lab"
import { styled, Tab, Tabs } from "@mui/material"

const tabListStyles = ({ theme: { components, typography } }: any) => ({
  "@media print": {
    display: "none"
  },
  "& .MuiTab-root": {
    marginBottom: "-2px",
    borderBottom: "1px solid white",
    "&:not(.Mui-selected):hover": {
      "&:after": {
        borderBottom: "2px solid #6b546a",
        bottom: 0,
        content: "''",
        left: 0,
        position: "absolute",
        width: "100%"
      },
      backgroundColor: "#efefef",
      color: "#6b546a"
    }
  },
  "& [class*='MuiTabs-indicator']": {
    backgroundColor: "#6b546a",
    bottom: "-1px",
    width: "60%"
  },
  "& > [class*='MuiTabs-scroller']": {
    overflow: "visible !important",
    zIndex: 2
  },
  backgroundColor: "#f9f9f9",
  border: "1px solid #ececec",
  borderRadius: 0,
  fontSize: typography.pxToRem(15),
  // @ts-ignore
  minHeight: components.Tabs.minHeight,
  overflow: "visible"
})

// @ts-ignore
export const StyledTabList = styled(TabList)(tabListStyles)
// @ts-ignore
export const StyledTabs = styled(Tabs)(tabListStyles)


interface StyledTabPanelProps extends TabPanelProps {
  background?: string
  noPaddings?: boolean
  theme: any
}

export const StyledTabPanel = styled(TabPanel)(
  // @ts-ignore
  ({
     background = "secondary",
     noPaddings,
     theme: { typography, withPalette }
   }: StyledTabPanelProps) => ({
    "&.MuiTabPanel-root[hidden]": {
      display: "none !important"
    },
    "&.MuiTabPanel-root": {
      position: "relative",
      zIndex: 1
    },
    backgroundColor: withPalette(background),
    border: [[1, "solid", "#ebebeb"]],
    borderRadius: [[0, 0, 4, 4]],
    borderTop: "none",
    fontSize: typography.pxToRem(14),
    padding: noPaddings && "0 !important"
  })
)

// @ts-ignore
export const CustomTabPanel = styled(TabPanel)(({ background, theme }) => ({
  // @ts-ignore
  backgroundColor: theme.withPalette(background),
  border: [[1, "solid", "#ececec"]],
  borderRadius: [[0, 0, 4, 4]],
  borderTop: "none",
  fontSize: theme.typography.pxToRem(14)
}))

export const StyledTab = styled(Tab)(({ theme: { breakpoints, components, typography } }) => ({
  "&.Mui-selected": {
    color: "#6b546a"
  },
  color: "#7f707d",
  fontSize: typography.pxToRem(15),
  fontWeight: "bold",
  margin: "0 20px",
  // @ts-ignore
  minHeight: components.Tabs.minHeight,
  opacity: 1,
  textTransform: "none",
  [breakpoints.up("sm")]: {
    minWidth: "80px"
  }
}))

export const CustomTab = styled(Tab)(({ theme }) => ({
  ["&.Mui-selected"]: {
    color: "#6b546a",
    opacity: 1
  },
  color: "#6b546a",
  fontSize: theme.typography.pxToRem(15),
  fontWeight: "bold",
  margin: "0 20px",
  // minHeight: theme.components.Tabs.minHeight,
  opacity: 0.7,
  textTransform: "initial",
  [theme.breakpoints.up("sm")]: {
    minWidth: "80px"
  }
}))

// @ts-ignore
export const CustomTabList = styled(TabList)(({ theme }) => ({
  "& [class*='MuiTabs-indicator']": {
    backgroundColor: "#6b546a !important",
    width: "60%"
  },
  backgroundColor: "#f9f9f9",
  border: "1px solid #ececec",
  borderRadius: [[4, 4, 0, 0]],
  fontSize: theme.typography.pxToRem(10),
  // @ts-ignore
  minHeight: theme.components?.Tabs.minHeight
}))
